/**
 * How an operation is named on the roster, and the phase -> operation-name
 * map the board's blocks read from.
 */
import { LaborStandard, LaborStandardOperation } from "../../../services/labor-standards-api";

// An operation leads with its own name ("Bed cap"); the operation type is only
// the category ("Exterior Upfit") and follows as quiet context.
export const operationLabel = (op: LaborStandardOperation, fallback: string): string =>
	op.name || op.operationTypeName || op.operationType?.name || fallback;

// phase id → the name of the operation that phase belongs to. A roster
// assignment only carries laborStandardPhaseId, so this is how an assignment
// bar learns which work it represents.
export const buildPhaseOperationNames = (standards: LaborStandard[]): Map<number, string> => {
	const names = new Map<number, string>();
	standards.forEach((standard) => {
		standard.operations?.forEach((operation) => {
			const label = operationLabel(operation, "");
			if (!label) {
				return;
			}
			operation.phases?.forEach((phase) => {
				if (phase.id !== undefined) {
					names.set(phase.id, label);
				}
			});
		});
	});
	return names;
};
